{
  "eyebrow": "Bevestig je abonnement",
  "title": "Bekijk en configureer.",
  "sub": "Je kan facturatiecyclus of abonnement op elk moment aanpassen in je beheerdersdashboard.",
  "yourPlan": "Jouw abonnement",
  "changePlan": "Wijzig abonnement",
  "billing": "Facturatiecyclus",
  "billingMonthLabel": "Maandelijks betalen",
  "billingMonthDesc": "Flexibel. Stop wanneer je wil.",
  "billingYearLabel": "Jaarlijks betalen",
  "billingYearDesc": "~17% korting. Eén keer per jaar gefactureerd.",
  "addons": "Add-ons",
  "addon": {
    "ssec": "Sociale zekerheid (check-in/out@work)",
    "ssecDesc": "Alleen België — automatische Dimona-aangifte.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live GPS voor bedrijfsvoertuigen. +€4 / voertuig / maand.",
    "vehicles": "Voertuigen",
    "projectAddon": "Projectbeheer add-on",
    "projectAddonDesc": "Schakel projectbeheer in voor Time Pro (extra werk, planning, onderaannemers)."
  },
  "employees": {
    "title": "Hoeveel medewerkers?",
    "active": "actieve gebruikers",
    "popular": "Meeste teams kiezen {{n}}"
  },
  "estimate": "Geschatte maandkost",
  "estimateNote": "Excl. btw. Per-gebruiker tarief op basis van actieve medewerkers.",
  "estimateUnavailable": "Prijscatalogus niet beschikbaar. Probeer opnieuw om de laatste prijzen te laden."
}
